import React from 'react';
import { Grid } from '@chakra-ui/react';

import useChatContext from 'hooks/session/useChatContext';
import ChatInput from './Input';
import MessageList from './Messages';

// In this component, we are toggling the visibility of the ChatWindow with CSS instead of
// conditionally rendering the component in the DOM. This is done so that the ChatWindow is
// not unmounted while a file upload is in progress.

interface Props {
  toggleGameLiftStreamsChatInput: any;
  componentHeight: number;
}

const Chat: React.FC<Props> = ({toggleGameLiftStreamsChatInput, componentHeight}: Props) => {
  const { isChatWindowOpen, messages, conversation } = useChatContext();

  return (
    <Grid
      templateRows="1fr fit-content(100%)"
      height={componentHeight}
    >
      <MessageList messages={messages} componentHeight={componentHeight}/>
      <ChatInput
        conversation={conversation!}
        isChatWindowOpen={isChatWindowOpen}
        toggleGameLiftStreamsInput={toggleGameLiftStreamsChatInput}
      />
    </Grid>
  );
};

export default Chat;
